export default {"src":"/_next/static/media/filters.f4829b29.svg","height":16,"width":24,"blurWidth":0,"blurHeight":0};